import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _map from "lodash/map";
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form'
import * as Yup from 'yup';
import { Checkboxes, DatePicker, makeRequired, makeValidate, Select, TextField } from 'mui-rff';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import grey from "@material-ui/core/colors/grey";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import clsx from "clsx";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';
import roLocale from "date-fns/locale/ro";
import Container from "@material-ui/core/Container";
import Fade from "react-reveal/Fade";
import Link from "@material-ui/core/Link";
import * as actions from "../../actions/products";
import * as action from "../../actions/pages";
import { submitTestdriveForm } from "../../actions/forms";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { PAGES_SLUGS } from "../../constants";
const staticFallbackData = {
    content: "<div><strong>Descoperă experiența .</strong><br><br>Pentru noi, siguranța oamenilor și grija față de mediu sunt întotdeauna pe primul loc: am oferit mereu libertate de mișcare, cu măsuri ridicate de protecție, precum și inovații care să sprijine sustenabilitatea.În contextul actual, interacțiunea cu fiecare dealer autorizat Volvo este realizată în deplină siguranță, cu respectarea tuturor normelor recomandate de specialiștii în domeniul sănătății publice.</div>",
    side_image: "https://volvo-cab-stage.s3-eu-west-1.amazonaws.com/uploads/pages/Qd4faWgSCpFGyDuIHu7oi2NEYbVkTDlVsNgNxUzy.webp",
    title: "Programează un Test Drive"
};

const TestDrivePage = () => {
    const dispatch = useDispatch();
    const pageData = useSelector(state => _get(state.pages.data, PAGES_SLUGS.TEST_DRIVE, {}));
    const pageContent = _get(pageData, 'data.ro', {});
    // const testDrive = _get(pageData, 'data.test_driver_section', {});
   // console.log("testDrive: ", pageData);
    const loading = useSelector(state => state.pages.request);
    const fetchError = useSelector(state => _get(state.pages.error, PAGES_SLUGS.TEST_DRIVE, null));
    const [finalTestDriveData, setFinalTestDriveData] = useState(staticFallbackData)
    const classes = useStyles();
    const subscription = { submitting: true };
    const [subscriptionState, setSubscriptionState] = useState(subscription);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (_isEmpty(pageData)) {
            dispatch(action.fetchPage(PAGES_SLUGS.TEST_DRIVE));
        }
    }, [])

    useEffect(() => {
        if (!_isEmpty(pageContent)) {
            setFinalTestDriveData(pageContent);
        } else if (!loading && (fetchError || _isEmpty(pageData))) {
            if (!_isEmpty(staticFallbackData)) {
                setFinalTestDriveData(staticFallbackData);
            } else {
                setFinalTestDriveData({});
            }
        }
    }, [pageData, loading, fetchError]);


    const onChange = () => {
        setSubscriptionState(subscriptionState === undefined ? subscription : undefined);
    };

    return (
        <div className={classes.root}>
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"left"}
                alignItems={"left"}
                className={classes.image}
                style={{ backgroundImage: `url(${_get(finalTestDriveData, 'content[0].attributes.side_image', '')})`, }}>
                <div className={classes.shadowDiv}></div>
                <Typography
                    gutterBottom
                    variant="h2"
                    component="h2"
                    className={classes.title}
                >{ReactHtmlParser(_get(finalTestDriveData, 'content[0].attributes.title', ''))}</Typography>
                <Typography className={classes.subtitle}>
                    {ReactHtmlParser(_get(finalTestDriveData, 'content[0].attributes.subtitle', ''))}
                </Typography>
                <Typography className={classes.overlaytext}>
                    {ReactHtmlParser(_get(finalTestDriveData, 'content[0].attributes.content', ''))}
                </Typography>

            </Box>
            <Fade>
                <Container maxWidth={"xl"} className={classes.bottomContainer}>
                    <MainForm subscription={subscriptionState} />
                </Container>
            </Fade>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        background: "#fff",
        margin: 12,
    },

    container: {
        position: "relative",
        width: "100%",
        [theme.breakpoints.down("sm")]: {},
    },
    shadowDiv: {
        [theme.breakpoints.up("sm")]: {
            display: "none",
            borderRadius: theme.shape.borderRadius,
        },
        [theme.breakpoints.between("sm", "md")]: {
            display: "none",
            borderRadius: theme.shape.borderRadius,
        },
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "block",
            borderRadius: theme.shape.borderRadius,
        },
    },
    bottomContainer: {
        background: "#E4E4E4",
        borderRadius: theme.shape.borderRadius,
        marginTop: 10,
        marginBottom: 0,
    },

    imageWrapper: {
        width: "100%",
    },

    image: {
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.35), rgba(0,0,0,0.35)), var(--background-image)`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        justifyContent: "center",
        minHeight: 540,
        padding: theme.spacing(3),
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
            minHeight: 350,
            backgroundPosition: "top top",
            justifyContent: "flex-end"
        },
    },
    titleBox: {
        padding: theme.spacing(6),
        paddingLeft: 88,
        paddingRight: theme.spacing(6),
        marginLeft: -88,
        background: "#fff",
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            marginLeft: 0,
        },
    },

    title: {
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(26),
        lineHeight: theme.typography.pxToRem(42),
        letterSpacing: "0.4px",
        zIndex: 1,
        marginLeft: "90px",
        marginBottom: theme.spacing(2),
        color: "#fff",
        [theme.breakpoints.down("sm")]: {
            fontSize: theme.typography.pxToRem(26),
            marginLeft: 10,
            marginBottom: theme.spacing(1),
        },
        text: {
            "& p": {
                color: "#fff",
                fontWeight: theme.typography.fontWeightLight,
                fontSize: theme.typography.pxToRem(16),
                lineHeight: theme.typography.pxToRem(24),
                letterSpacing: "0",
                marginBottom: theme.spacing(2),
                wordBreak: "break-word",
            },
            "& ul": {
                paddingLeft: theme.spacing(3),
                "& li": {
                    color: "#fff",
                    fontWeight: theme.typography.fontWeightLight,
                    fontSize: theme.typography.pxToRem(16),
                    lineHeight: theme.typography.pxToRem(24),
                    letterSpacing: "0",
                    marginBottom: theme.spacing(0),
                    wordBreak: "break-word",
                },
            },
            "& a": {
                color: "#fff",
                fontWeight: theme.typography.fontWeightLight,
                fontSize: theme.typography.pxToRem(16),
                lineHeight: theme.typography.pxToRem(24),
                letterSpacing: "0",
                marginBottom: theme.spacing(0),
                wordBreak: "break-word",
                position: "relative",
                textDecoration: "none",

                "&:hover": {
                    textDecoration: "none",
                },

                "&:before": {
                    content: `''`,
                    position: "absolute",
                    width: "0",
                    height: "1px",
                    bottom: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: theme.palette.primary.main,
                    transition: theme.transitions.create(["width"], {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                },

                "&:hover:before": {
                    width: "100%",
                },
            },
        },
    },
    overlaytext: {
        color: "#fff",
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(24),
        letterSpacing: "0",
        marginBottom: theme.spacing(2),
        marginLeft: "90px",
        maxWidth: "40%",
        zIndex: 1,
        "& > *": {
            display: "block",
            marginRight: theme.spacing(2),
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
            fontSize: theme.typography.pxToRem(16),
            lineHeight: theme.typography.pxToRem(22),
            marginLeft: 10,
            marginBottom: theme.spacing(0),
        },

    },
    subtitle: {
        color: "#fff",
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(24),
        letterSpacing: "0",
        marginBottom: theme.spacing(2),
        marginLeft: "90px",
        maxWidth: "40%",
        zIndex: 1,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
            fontSize: theme.typography.pxToRem(16),
            lineHeight: theme.typography.pxToRem(24),
            marginLeft: 10,
            marginBottom: theme.spacing(1),
        },
    },
}));


const schema = Yup.object().shape({
    model_id: Yup.number().required("Camp obligatoriu"),
    dealership_id: Yup.number().required("Camp obligatoriu"),
    proposed_date: Yup.date().required("Camp obligatoriu"),
    first_name: Yup.string().required("Camp obligatoriu"),
    last_name: Yup.string().required("Camp obligatoriu"),
    email: Yup.string().required("Camp obligatoriu").email("Email invalid"),
    phone: Yup.string().required("Camp obligatoriu").matches(/^[0-9]{10}$/, 'Telefon invalid'),
    terms: Yup.boolean()
        .oneOf([true], 'Camp obligatoriu')
        .required("Camp obligatoriu"),
});

/**
 * Uses the optional helper makeValidate function to format the error messages
 * into something usable by final form.
 */
const validate = makeValidate(schema);

/**
 * Grabs all the required fields from the schema so that they can be passed into
 * the components without having to declare them in both the schema and the component.
 */
const required = makeRequired(schema);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function MainForm({ subscription }) {

    const classes = useFormStyles();
    const history = useHistory();
    const [openTermsDialog, setOpenTermsDialog] = useState(false);
    const [currentModel, setCurrentModel] = useState('');
    const [currentDealership, setCurrentDealership] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openTyDialog, setOpenTyDialog] = useState(false);
    const dispatch = useDispatch();

    const allModels = useSelector(state => state.modelsList.data);
    // const allModelsLoading = useSelector(state => state.modelsList.request);
    // const allModelsError = useSelector(state => state.modelsList.error);

    const allDealerships = useSelector(state => state.dealerships.data);
    const allDealersLoading = useSelector(state => state.dealerships.request);
    // const allDealersError = useSelector(state => state.dealerships.error);

    useEffect(() => {
        dispatch(actions.fetchAllModels())
        dispatch(actions.fetchDealerships())
    }, [])

    useEffect(() => {
        if (window.snowplow) {
            window.snowplow('enableFormTracking');
        }
    }, []);

    const getModels = () => {
        if (_isEmpty(allModels)) {
            return [];
        } else {
            let options = [
                { label: 'Alege...', value: '', disabled: true },
            ];
            _map(allModels, (item) => {
                options.push(
                    { label: item.name, value: item.id }
                )
            })
            // return options;
            return _map(options, (item) => {
                return <MenuItem key={item.value} onClick={(e) => {
                    // handleModelChange(item.value);
                }} value={item.value}>{item.label}</MenuItem>
            })
        }
    }

    const getDealerships = () => {
        if (_isEmpty(allDealerships)) {
            return [];
        } else {
            let options = [
                { label: 'Alege...', value: '', disabled: true },
            ];
            _map(allDealerships, (item) => {
                options.push(
                    { label: item.name, value: item.id }
                )
            })
            return options;
        }
    }

    const initialValues = {
        // best: [],
        // terms: false,
        // gender: '',
        // birthday: new Date('2014-08-18'),
    };

    const onSubmit = async (values, form) => {
        try {
            await dispatch(submitTestdriveForm(values))
            // setTimeout(form.restart);
            // setOpenTyDialog(true);
            history.push(`/${PAGES_SLUGS.TESTDRIVE_THANK_YOU}`);
        } catch (errors) {
            setOpenSnackbar(true);
            return { [FORM_ERROR]: _get(errors, "message", "Opps, Submit faild!") }
        }
    };

    const handleTermsAndConditionsDialog = () => {
        // console.log("checked:",value)
        setOpenTermsDialog(!openTermsDialog);
    };

    /*Error notification*/

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const _handleTyDialogClose = () => {
        setOpenTyDialog(false);
    };
    return (
        <div className={classes.formRoot}>
            <Form
                onSubmit={onSubmit}
                // initialValues={submittedValues ? submittedValues : initialValues}
                subscription={subscription}
                validate={validate}
                key={subscription}
                render={({
                    submitError,
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values
                }) => {
                    return (
                        <form onSubmit={handleSubmit} noValidate={true} autoComplete="new-password"
                            id="test_drive_form">
                            <Grid container spacing={3} className={classes.formRow}>
                                <Grid item sm={4} xs={12}>

                                    <Select
                                        label="Selectează model"
                                        name="model_id"
                                        required={required.model_id}
                                        // data={getModels()}
                                        variant="outlined"
                                        inputProps={{
                                            classes: {
                                                root: classes.inputRoot,
                                                icon: classes.dropdownIcon
                                            }
                                        }}
                                        IconComponent={ExpandMoreIcon}
                                    // value={currentModel}
                                    // onChange={handleModelChange}
                                    // InputProps={{
                                    //     startAdornment: (
                                    //         <InputAdornment position="start">
                                    //             <Icon
                                    //                 className={clsx("brand-icon-car", classes.icon)}/>
                                    //         </InputAdornment>
                                    //     ),
                                    // }}
                                    >
                                        {getModels()}
                                    </Select>

                                </Grid>

                                <Grid item sm={4} xs={12}>
                                    <Select
                                        label="Selectează dealer"
                                        name="dealership_id"
                                        required={required.dealership_id}
                                        data={getDealerships()}
                                        variant="outlined"
                                        inputProps={{
                                            classes: {
                                                root: classes.inputRoot,
                                                icon: classes.dropdownIcon
                                            }
                                        }}
                                        IconComponent={ExpandMoreIcon}
                                        disabled={/*currentModel == "" ||*/ allDealersLoading}

                                    // InputProps={{
                                    //     startAdornment: (
                                    //         <InputAdornment position="start">
                                    //             <Icon
                                    //                 className={clsx("brand-icon-dealer", classes.icon)}/>
                                    //         </InputAdornment>
                                    //     ),
                                    // }}
                                    />
                                </Grid>

                                <Grid item sm={4} xs={12}>
                                    <ThemeProvider theme={datePickerTheme}>
                                        <DatePicker
                                            // disableToolbar
                                            // variant="inline"
                                            // orientation="landscape"
                                            autoOk
                                            format="dd/MM/yyyy"
                                            locale={roLocale}
                                            label="Data dorită"
                                            name="proposed_date"
                                            required={required.proposed_date}
                                            dateFunsUtils={DateFnsUtils}
                                            inputVariant="outlined"
                                            InputProps={{
                                                classes: {
                                                    root: classes.inputRoot
                                                }
                                            }}
                                            minDate={new Date()}
                                        // InputProps={{
                                        //     startAdornment: (
                                        //         <InputAdornment position="start">
                                        //
                                        //             <Icon
                                        //                 className={clsx("brand-icon-date", classes.icon)}/>
                                        //
                                        //         </InputAdornment>
                                        //     ),
                                        // }}
                                        />
                                    </ThemeProvider>
                                </Grid>
                            </Grid>
                            <Grid>
                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}
                                    className={classes.driverData}>
                                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}
                                        className={classes.driverDataInner}>
                                        <Icon
                                            className={clsx("brand-icon-contact-details", classes.icon)} />
                                        <Typography>Detalii contact</Typography>
                                    </Box>
                                    <Divider className={classes.divider} />
                                </Box>
                                <Grid container justify={"center"} spacing={3} className={classes.formRow}>
                                    <Grid item sm={5} xs={12}>
                                        <TextField
                                            label="Prenume"
                                            name="first_name"
                                            required={required.first_name}
                                            variant="outlined"
                                            InputProps={{
                                                classes: { root: classes.inputRoot }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={5} xs={12}>
                                        <TextField
                                            label="Nume"
                                            name="last_name"
                                            required={required.last_name}
                                            variant="outlined"
                                            InputProps={{
                                                classes: { root: classes.inputRoot }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={5} xs={12}>
                                        <TextField
                                            label="Email"
                                            name="email"
                                            type="email"
                                            required={required.email}
                                            variant="outlined"
                                            InputProps={{
                                                classes: { root: classes.inputRoot }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={5} xs={12}>
                                        <TextField
                                            label="Telefon"
                                            name="phone"
                                            type="tel"
                                            required={required.phone}
                                            variant="outlined"
                                            fullWidth
                                            InputProps={{
                                                classes: { root: classes.inputRoot }
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}
                                    className={classes.driverData}>
                                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}
                                        className={classes.driverDataInner}>
                                        <Typography>Mesaj</Typography>
                                    </Box>
                                    <Divider className={classes.divider} />
                                </Box>

                                <Grid container justify={"center"} className={classes.formRow}>
                                    <Grid item sm={5} xs={12} className={classes.formTextbox}>
                                        <TextField
                                            name="message"
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            fullWidth
                                            classes={{
                                                root: classes.inputRoot
                                            }}

                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems={"center"} direction={"column"}
                                    className={classes.formCheckbox}>
                                    <Grid container item xs={12} sm={5}
                                    >
                                        <Checkboxes
                                            name="terms"
                                            formControlLabelProps={{
                                                classes: { label: classes.checkboxLabel }
                                            }}
                                            required={required.terms}
                                            color="primary"
                                            data={{
                                                label: <span>Sunt de accord cu <Link
                                                    href={`/${PAGES_SLUGS.TERMS_AND_CONDITIONS}`} target={"_blank"}>termenii și condițiile</Link>.</span>,
                                                value: false,
                                            }}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} sm={5}>

                                        <Checkboxes
                                            name="contact_optin"
                                            formControlLabelProps={{
                                                classes: { label: classes.checkboxLabel }
                                            }}
                                            color="primary"
                                            data={{
                                                label: <span>Doresc să primesc informații și oferte legate de modelele Volvo.</span>,
                                                value: false,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {/*<Grid container justify={"center"} className={classes.formRow}>*/}
                                {/*    <Grid container justify={"center"} item sm={5} xs={12}*/}
                                {/*          className={classes.formCheckbox}>*/}
                                {/*        <Debug/>*/}
                                {/*    </Grid>*/}
                                {/*</Grid>*/}
                                {/*{submitError && <Grid container justify={"center"} className={classes.formRow}>*/}
                                {/*    <Grid container justify={"center"} item sm={5} xs={12}*/}
                                {/*          className={classes.formTextbox}>*/}
                                {/*        <div className="error">{submitError}</div>*/}
                                {/*    </Grid>*/}
                                {/*</Grid>}*/}
                                <Grid container justify={"center"} className={classes.formRow}>
                                    <Grid item>
                                        <Button variant="contained" color="primary" className={classes.submitButton} type="submit" disabled={submitting}>
                                            rezervă test drive
                                            {submitting &&
                                                <CircularProgress size={24} className={classes.buttonProgress} />}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                                <Alert onClose={handleCloseSnackbar} severity="error">
                                    Oops! Something went wrong! Please check your info and retry.
                                </Alert>
                            </Snackbar>
                        </form>
                    )
                }
                }
            />

            {/*<TermsDialogWidget*/}
            {/*    open={openTermsDialog}*/}
            {/*    onClose={handleTermsAndConditionsDialog}*/}
            {/*/>*/}

            {/*<TestdriveTyDialogWidget*/}
            {/*    slug={PAGES_SLUGS.TESTDRIVE_THANK_YOU}*/}
            {/*    open={openTyDialog}*/}
            {/*    onClose={_handleTyDialogClose}*/}
            {/*    onOpen={() => {*/}
            {/*    }}*/}
            {/*/>*/}

        </div>
    );
}

const datePickerTheme = createMuiTheme({
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: grey['900'],
            },
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                // backgroundColor: lightBlue.A200,
                // color: "white",
            },
        },
        MuiPickersDay: {
            day: {
                color: grey.A700,
            },
            daySelected: {
                backgroundColor: grey["400"],
            },
            dayDisabled: {
                color: grey["100"],
            },
            current: {
                color: grey["900"],
            },
        },
        MuiPickersModal: {
            dialogAction: {
                color: grey["400"],
            },
        },
    },
});

const useFormStyles = makeStyles((theme) => ({

    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    submitButton: {
        backgroundColor: theme.palette.primary.main + 'B3',
        color: '#fff',
        '&:hover': {
            backgroundColor: theme.palette.primary.main + 'D9',
        },
        withLineDivider: {
            position: "relative",
        },
    },
    formRoot: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(8),


    },
    inputRoot: {
        background: "#fff",
    },
    formRow: {},
    formTextbox: {
        paddingTop: theme.spacing(0),
    },
    formCheckbox: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(5),
    },
    formTextboxLabel: {
        textAlign: "center",
        paddingBottom: theme.spacing(3),
    },
    formControl: {},
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    driverData: {
        position: "relative",
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),

    },
    driverDataInner: {
        margin: "0 auto",
        padding: `0 ${theme.spacing(3)}px`,
        paddingInline: theme.spacing(2),
        background: "#E4E4E4",
        zIndex: 2,
    },
    divider: {
        width: '100%',
        position: "absolute",
        top: "50%",
        left: 0,
        transform: "translateY(-50%)",
    },
    icon: {
        fontSize: 32,
        marginRight: 10,
    },
    dropdownIcon: {
        color: theme.palette.primary.main,
    },
    checkboxLabel: {
        fontSize: theme.typography.pxToRem(14),
        // lineHeight: theme.typography.pxToRem(32),
    }
}));
export default TestDrivePage;
